<template>
  登录历史记录
</template>

<script>
export default {
  name: "login_history"
}
</script>

<style scoped>

</style>